import * as React from 'react';
import { observer } from 'mobx-react';
import * as parse from 'date-fns/parse';
import * as distanceInWordsToNow from 'date-fns/distance_in_words_to_now';

// Declarations
import { IPeopleItem } from './AppNetworkPeopleSearch';

// Components
import Box from '../../components/Box';
import Paper from '../../components/Paper';
import Typography from '../../components/Typography';

// Style
import './PeopleListItem.css';

// Component
export interface IProps {
  user: IPeopleItem;
  onClick: () => void;
}

function PeopleListItem({ user, onClick }: IProps) {
  return (
    <Paper className="AppWorkspacePeople__PeopleListItem" onClick={onClick}>
      <img
        className="AppWorkspacePeople__PeopleListItem__avatar"
        src={user.photoUrl || '//i.imgur.com/wkbr0Z0.png'}
        height="96"
        width="96"
        style={{ minWidth: 96 }}
      />
      <div className="AppWorkspacePeople__PeopleListItem__content">
        <Typography
          color="inherit"
          className="AppWorkspacePeople__PeopleListItem__content__primary"
          type="subheading"
        >
          {`${user.firstName} ${user.lastName}`}
        </Typography>
        <Box mt={1}>
          <Typography
            color="inherit"
            className="AppWorkspacePeople__PeopleListItem__content__secondary"
            type="caption"
          >
            {user.lastLogin === null
              ? 'Not Registered'
              : `Active ${distanceInWordsToNow(parse(`${user.lastLogin}Z`))} ago`}
          </Typography>
        </Box>
      </div>
    </Paper>
  );
}

export default observer(PeopleListItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkPeopleSearch/PeopleListItem.tsx